module.exports = __webpack_public_path__ + "img/upload.d8f008ac.png";